export var T = function () { return true; };
